const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

const { debounce } = window.BAO.Utils

class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.currentMode = this.isMobile() ? 'mobile' : 'desktop'

    this.checkInertState = this.checkInertState.bind(this)
    this.checkInertState()
    this.debouncedResize = debounce(this.handleResize.bind(this), 240)
    this.listeners.add(window, 'resize', this.debouncedResize)

    if (this.els.slide.elements.length <= 1) return

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    this.handleLoadMore = this.handleLoadMore.bind(this)

    this.listeners.add(this, 'click', this.handleLoadMore)
  }

  handleLoadMore (event) {
    const target = event.target.closest(this?.els['more-button']?.selector)

    if (!target) return

    this.els.more.element.remove()

    this.els.slide.elements.forEach((slideEl, index) => {
      slideEl.classList.remove('prd-Media_Item-overflow')
      slideEl.removeAttribute('inert')

      if (index === 4) {
        window.setTimeout(() => {
          slideEl.querySelector('a')?.focus()
        }, 100)
      }
    })
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 1,
        },
        breakpoints: {
          '(min-width: 901px)': {
            disabled: true,
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }

  handleResize () {
    const newMode = this.isMobile() ? 'mobile' : 'desktop'

    if (newMode !== this.currentMode) {
      this.currentMode = newMode
      this.checkInertState()
    }
  }

  checkInertState () {
    if (this.currentMode === 'desktop') {
      this.els.slide.elements.forEach((slideEl) => {
        if (slideEl.classList.contains('prd-Media_Item-overflow')) {
          slideEl.setAttribute('inert', '')
        }
      })
    } else {
      this.els.slide.elements.forEach((slideEl) => {
        slideEl.removeAttribute('inert')
      })
    }
  }

  isMobile () {
    return window.BAO.MediaBreakpoints.isMd === false
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
